// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"d98575f1","453":"c153058e","461":"d717ce7a","942":"7a94e5ea"}[chunkId] + ".chunk.js";
};